import { combineReducers } from 'redux';
import { campaign } from './campaign/campaign.reducer';
import { creative } from './creative/creative.reducer'
import { comment } from './comment/comment.reducer'
export const brief = combineReducers({
    campaign,
    comment,
    creative
});